module.exports = __webpack_public_path__ + "img/service-edu2.661b5e8d.svg";